import React from "react";
import "./Footer.css";
import { Row, Col } from "reactstrap";

export default class Example extends React.Component {
  render() {
    return (
      <footer>
        <div className="footer-wrapper">
          <Row>
            <Col md="6">
              <img
                className="img-fluid logo"
                alt="logo-integrators"
                src={require("../../img/integrator_logo.png")}
              />
              <p>
                Stay up-to-date on the latest in end-to-end integration and
                integration landscapes. Get ahead of the competition, join the
                certified professionals building integrations faster and smarter
                for a better digital world.
              </p>
            </Col>
            <Col md="6" className="text-right align-self-center">
              <ul>
                <li>
                  <a href="/get-certified">GET CERTIFIED</a>
                </li>
                <li>
                  <a href="/business-benefits">BUSINESS BENEFITS</a>
                </li>
                <li>
                  <a href="/events">SCHEDULE</a>
                </li>
                <li>
                  <a href="/aboutus">ABOUT US</a>
                </li>
                <li>
                  <a href="/community">COMMUNITY</a>
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </footer>
    );
  }
}